export default "__VITE_ASSET__Ctw6h74f__"